export const THREED_COLLECTION_REQUEST='THREED_COLLECTION_REQUEST';
export const THREED_COLLECTION_SUCCESS='THREED_COLLECTION_SUCCESS';
export const THREED_COLLECTION_FAIL='THREED_COLLECTION_FAIL';

export const THREED_BET_REQUEST='THREED_BET_REQUEST';
export const THREED_BET_SUCCESS='THREED_BET_SUCCESS';
export const THREED_BET_FAIL='THREED_BET_FAIL';
